import { ChangeDetectionStrategy, Component, inject, Input, output, ViewEncapsulation } from '@angular/core';
import { FiChecklistAiAssistanceDialogComponent } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance-dialog/checklist-ai-assistance-dialog.component';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiChecklist2ReportTimePeriodType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-time-period-type';
import { IAIChecklist2Model } from '@fi-shared/fi-ai-assistance/fi-ai-assistance';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';

@Component({
    selector: 'fi-checklist-ai-assistance-card',
    template: `
        <mat-card class="checklist-ai-assistance-card fi-rounded-card">
            <button mat-button class="checklist-ai-assistance-button" (click)="openAIAssistanceDialog()">
                <span class="button-label-container">
                    <mat-icon class="far fa-user-robot ai-assistance-icon" />
                    <span class="button-label">{{ 'text_editor.ai_assistance' | fiAppText }}</span>
                    <svg
                        class="beta-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="15"
                        viewBox="0 0 24 15"
                        fill="none"
                    >
                        <path
                            d="M21.8438 0.0117219C23.055 0.140662 24 1.20735 24 2.50065V12.5033L23.9888 12.7572C23.8725 13.9333 22.9762 14.8711 21.8475 14.9883L21.6038 15H2.40375L2.16 14.9883C1.03125 14.8672 0.13125 13.9333 0.01875 12.7572L0 12.5033V2.50065C0 1.20735 0.945 0.140662 2.15625 0.0117219L2.4 0H21.6L21.8438 0.0117219ZM2.4 1.87549C2.07 1.87549 1.8 2.15681 1.8 2.50065V12.5033C1.8 12.8471 2.07 13.1284 2.4 13.1284H21.6C21.93 13.1284 22.2 12.8471 22.2 12.5033V2.50065C22.2 2.15681 21.93 1.87549 21.6 1.87549H2.4ZM5.4 4.37614C6.39375 4.37614 7.2 5.2162 7.2 6.25163C7.2 6.65408 7.07625 7.02527 6.87 7.33003C7.2525 7.67387 7.5 8.18182 7.5 8.75228C7.5 9.78771 6.69375 10.6278 5.7 10.6278H4.2C3.91125 10.6278 3.6675 10.4129 3.61125 10.1276L3.6 10.0026V5.0013C3.6 4.65746 3.87 4.37614 4.2 4.37614H5.4ZM11.4 4.37614C11.73 4.37614 12 4.65746 12 5.0013C12 5.34514 11.73 5.62647 11.4 5.62647H9.6V6.87679H10.8C11.13 6.87679 11.4 7.15811 11.4 7.50195C11.4 7.84579 11.13 8.12712 10.8 8.12712H9.6V9.37744H11.4C11.73 9.37744 12 9.65877 12 10.0026C12 10.3464 11.73 10.6278 11.4 10.6278H9C8.67 10.6278 8.4 10.3464 8.4 10.0026V5.0013L8.41125 4.87627C8.4675 4.59104 8.71125 4.37614 9 4.37614H11.4ZM15.6 4.37614C15.93 4.37614 16.2 4.65746 16.2 5.0013C16.2 5.34514 15.93 5.62647 15.6 5.62647H15V10.0026C15 10.3464 14.73 10.6278 14.4 10.6278C14.07 10.6278 13.8 10.3464 13.8 10.0026V5.62647H13.2C12.87 5.62647 12.6 5.34514 12.6 5.0013C12.6 4.65746 12.87 4.37614 13.2 4.37614H15.6ZM18.9 4.37614C19.7288 4.37614 20.4 5.07554 20.4 5.93905V10.0026C20.4 10.3464 20.13 10.6278 19.8 10.6278C19.47 10.6278 19.2 10.3464 19.2 10.0026V8.75228H18V10.0026C18 10.3464 17.73 10.6278 17.4 10.6278C17.07 10.6278 16.8 10.3464 16.8 10.0026V5.93905C16.8 5.07554 17.4713 4.37614 18.3 4.37614H18.9ZM4.8 9.37744H5.7C6.03 9.37744 6.3 9.09612 6.3 8.75228C6.3 8.40844 6.03 8.12712 5.7 8.12712H4.8V9.37744ZM18.3 5.62647C18.135 5.62647 18 5.76713 18 5.93905V7.50195H19.2V5.93905C19.2 5.76713 19.065 5.62647 18.9 5.62647H18.3ZM4.8 6.87679H5.4C5.73 6.87679 6 6.59547 6 6.25163C6 5.90779 5.73 5.62647 5.4 5.62647H4.8V6.87679Z"
                        />
                    </svg>
                </span>
            </button>
        </mat-card>
    `,
    styleUrl: './checklist-ai-assistance-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-ai-assistance-card' },
    standalone: false,
})
export class FiChecklistAIAssistanceCard {
    @Input({ required: true }) selectedLanguageId: FiApplicationLanguageType;
    public onAIAssistanceDialogOpenChange = output<boolean>();
    public aiResponseChanged = output<IAIChecklist2Model>();

    private appTextService = inject(AppTextService);
    private fiDialogsService = inject(FiDialogsService);

    protected openAIAssistanceDialog(): void {
        this.onAIAssistanceDialogOpenChange.emit(true);

        this.fiDialogsService
            .custom({
                contentComponentRef: FiChecklistAiAssistanceDialogComponent,
                contentComponentData: {
                    selectedLanguageId: this.selectedLanguageId,
                },
                headerText: this.appTextService.get('text_editor.ai_assistance'),
                headerIconClass: 'far fa-user-robot BrandedColor',
                isHeaderDividerShown: true,
                hideDialogTopBorder: true,
                headerDividerClass: 'BrandedBorderColor',
                footerCssClass: 'hidden',
                isBetaBadgeShown: true,
                config: {
                    panelClass: [
                        'fi-rounded-dialog-panel',
                        'fi-checklist-ai-assistance-dialog-panel',
                        'fi-rounded-dialog-full-round-buttons',
                    ],
                    autoFocus: false,
                    width: '80%',
                    maxWidth: '1100px',
                    maxHeight: '665px',
                    //minHeight: '100%',
                    height: '100%',
                    restoreFocus: false,
                },
            })
            .onYesButtonClick((result) => {
                this.aiResponseChanged.emit(result.aiResponse);
            })
            .afterClosed(() => this.onAIAssistanceDialogOpenChange.emit(false));
    }

    protected readonly FiChecklist2ReportTimePeriodType = FiChecklist2ReportTimePeriodType;
}
